import { LintMood } from "./LintMood";

const steps = [
  { title: "Hand Lint your project", body: "Multiple repositories. One project. No setup drama." },
  { title: "Lint reads everything", body: "Code, architecture, dependencies, and how they quietly connect." },
  { title: "He spots what matters", body: "Security, architecture, compliance and the risks others miss." },
  { title: "He explains it plainly", body: "Plain English, not engineering jargon. No judgement." },
  { title: "You get a calm plan", body: "Clear instructions you can hand straight back to your AI builder." },
  { title: "You ship, relieved", body: "You know what you're releasing, and why it's ready." },
];

export function Journey() {
  return (
    <section className="bg-surface-elevated py-20 sm:py-28" data-testid="journey">
      <div className="mx-auto grid max-w-6xl gap-12 px-5 sm:px-8 lg:grid-cols-[0.8fr_1.2fr]">
        <div className="lg:sticky lg:top-24 lg:self-start">
          <p className="text-sm font-semibold uppercase tracking-[0.16em] text-brand">Working with Lint</p>
          <h2 className="font-display mt-3 text-3xl font-semibold tracking-tight text-navy sm:text-5xl">
            From &ldquo;I think I&apos;m done&rdquo; to &ldquo;I know I&apos;m ready.&rdquo;
          </h2>
          <div className="mt-10">
            <LintMood
              from="laptop"
              to="nod"
              alt="Lint working through your project"
              say={["Reading your repos now…", "Six calm steps. You've got this."]}
              bubbleClass="max-w-[230px]"
              className="w-52 sm:w-60"
              testId="journey-lint"
            />
          </div>
        </div>
        <ol className="grid gap-x-10 gap-y-10 sm:grid-cols-2">
          {steps.map((step, index) => (
            <li key={step.title} className="relative border-t border-border pt-5" data-testid={`journey-step-${index}`}>
              <span className="font-display text-4xl font-semibold text-sage">
                {String(index + 1).padStart(2, "0")}
              </span>
              <h3 className="mt-2 text-lg font-semibold text-navy">{step.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-ink-muted">{step.body}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
